export const meta = {
  title: 'Privacy Policy',
  description:
    'How this site handles planner storage, share links and explicitly enabled analytics.',
  updated_at: '2026-10-08',
};

## Build Planner Storage

The planner saves selected ability identifiers in your browser's localStorage under `control-resonant-build-v1`. Reset All clears the saved plan. No account or game-save upload is required.

## Shared URLs

Shared links include selected ability identifiers. Anyone with the link can read those choices. URLs may be retained in browser history, hosting logs and analytics; do not include personal information.

## Analytics and Session Insights

When explicitly configured, Google Analytics 4 receives page-view and device information, and Microsoft Clarity provides interaction analytics and session replay. These providers may use cookies and process device, network and interaction information under their own policies. This site sends denied storage consent signals to request limited cookieless tracking. Actual cookie behavior also depends on the Clarity project configuration; the provider may set cookies until that configuration requires consent. Clarity masks sensitive fields by default; do not enter private information into planner links. The site does not upload the saved localStorage build as an account profile.

## Preferences and Controls

Theme and planner preferences may be stored locally. A language preference or attribution cookie may be used. Browser privacy settings can block analytics and storage; the public guides remain readable. Clear site data or use Reset All to remove saved planner choices.

## External Links and Hosting

Source links lead to sites with independent privacy practices. Cloudflare may retain hosting request and security logs.

## Contact

For privacy questions, contact [support@controlresonanttools.online](mailto:support@controlresonanttools.online).
